// Define a service using a base URL and expected endpoints
// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'
import {  DailyScheduleEntryVM, SpecialEventVm, UpdateExceptionScheduleArgs, UpdateWeeklyScheduleArgs } from './types';
import { ICalendar } from '../../automationObjects/Functions/Calendar';
import { cacher } from "../rtkQueryCacheUtils";

export const schedulersApi = createApi({
    reducerPath: 'schedulersApi',
    baseQuery: fetchBaseQuery({
        baseUrl: apiConfig.schedulersApiUrl,
        prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
    }),
    tagTypes: [...cacher.defaultTags,'schedulers'],
    endpoints: (builder) => ({
        getWeeklySchedule: builder.query<DailyScheduleEntryVM[], { resourceGroupId: string, objectId: string}>({
            query: (args) =>  `v2/schedulers/${args.resourceGroupId}/${args.objectId}/weeklySchedule`,
        }),
        updateWeeklySchedule: builder.mutation<any, UpdateWeeklyScheduleArgs>({
            query: (args) => ({
                url: `v2/schedulers/${args.resourceGroupId}/${args.objectId}/weeklySchedule`,
                method: 'post',
                body: args.body
            })
        }),

        getExceptionSchedule: builder.query<SpecialEventVm[], { resourceGroupId: string, objectId: string}>({
            query: (args) =>  `v2/schedulers/${args.resourceGroupId}/${args.objectId}/exceptionSchedule`,
        }),
        updateExceptionSchedule: builder.mutation<any, UpdateExceptionScheduleArgs>({
            query: (args) => ({
                url: `v2/schedulers/${args.resourceGroupId}/${args.objectId}/exceptionSchedule`,
                method: 'post',
                body: args.body
            })
        }),

        getAssignableCalendars: builder.query<ICalendar[], { resourceGroupId: string, objectId: string}>({
            query: (args) =>  `v2/schedulers/${args.resourceGroupId}/${args.objectId}/assignableCalendars`,
        }),
    })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetWeeklyScheduleQuery,
    useGetExceptionScheduleQuery,
    useUpdateWeeklyScheduleMutation,
    useUpdateExceptionScheduleMutation,
    useGetAssignableCalendarsQuery
} = schedulersApi


